module.exports = __webpack_public_path__ + "static/media/HowToVideo.6ef48b44.svg";